/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import template from './ax-line-item-list-page.component.html';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {LineItemBulkActionService} from '../line-item/line-item-bulk-action.service';
import {LineItemApiService, LineItemModel} from '../line-item/line-item-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-ax-line-item-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AxLineItemListPageComponent implements OnInit {
  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  readonly itemStateName = 'app.adv.line-items.line-item';
  readonly marketplaceProductItemStateName = 'app.adm.marketplace-products.marketplace-product';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'userState'},
    {param: 'executionState'},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'objectives', numeric: true},
    {param: 'updateTime'}
  ];

  readonly userStateOptions = ['PROPOSED', 'SUBMITTED', 'RESERVED', 'APPROVED', 'PAUSED', 'STOPPED'];
  readonly executionStateOptions = ['NOT_READY', 'READY', 'RUNNING', 'ENDED'];
  readonly sourceOptions = ['DIRECT', 'MARKETPLACE', 'SELF_SERVICE'];
  readonly list = inject(SignalAdminResourceListStateFactory).create<LineItemModel>(
    inject(LineItemApiService),
    {listId: 'fullAxLineItemList', baseTable: 'lineItem', additionalParams: {excludeIfMissing: 'axProductId'}},
    inject(DestroyRef)
  );

  private readonly api = inject(LineItemApiService);
  private readonly lineItemBulkActionService = inject(LineItemBulkActionService);

  ngOnInit(): void {
    this.list.load();
  }

  openBulkActions(): void {
    this.lineItemBulkActionService.createBulkAction({
      bulkSelection: this.list.selected(),
      miscBulkAction: (modal: any, controller: any, items: Partial<LineItemModel>[], _resource: any, params: any) => {
        this.api.bulkSave(params || {}, items).subscribe({
          next: () => {
            modal.close();
            this.list.deselectAll();
            this.list.load();
          },
          error: () => {
            controller.form = controller.form || {};
            controller.form.bulkError = true;
          }
        });
      }
    })();
  }
}
